 $(document).ready(function(){

    $('.multicolumn_data').slick(
    
    {
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:"<button type='button' class='slick-prev pull-left'><svg width='8' height='14' class='icon icon-arrow-left' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M2.93895 7.00003L7.88867 11.9498L6.47446 13.364L0.110452 7.00003L6.47446 0.636135L7.88867 2.05033L2.93895 7.00003Z' fill='currentColor'></path></svg></i></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><svg width='8' height='14' class='icon icon-arrow-right' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M5.06056 6.99997L0.11084 2.0502L1.52505 0.635986L7.88906 6.99997L1.52505 13.3639L0.11084 11.9497L5.06056 6.99997Z' fill='currentColor'></path></svg></button>",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
        }
    );
   
});